import { useState } from 'react';
import { Modal } from './ui/Modal';
import { Button } from './ui';
import { apiClient } from '../lib/api';
import { CURRENT_TERMS_VERSION } from '../constants/terms';

import styles from './TermsAcceptanceModal.module.css';

interface TermsAcceptanceModalProps {
  isOpen: boolean;
  onAccepted: () => void;
  /** Origem do aceite, registrada para auditoria do consentimento. */
  context?: 'post-login-modal' | 'signup' | 'reacceptance';
}

export default function TermsAcceptanceModal({
  isOpen,
  onAccepted,
  context = 'post-login-modal',
}: TermsAcceptanceModalProps) {
  const [loading, setLoading] = useState(false);

  const handleAccept = async () => {
    setLoading(true);
    try {
      const res = await apiClient('/terms/accept', {
        method: 'POST',
        body: JSON.stringify({ version: CURRENT_TERMS_VERSION, context }),
      });
      if (!res.ok) {
        throw new Error('Failed to accept terms');
      }
      onAccepted();
    } catch (error) {
      console.error('Error accepting terms:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={() => {}} closeable={false} title="Termos de Uso" size="md">
      <div className={styles.content}>
        <p className={styles.text}>
          A Athena utiliza inteligência artificial para gerar correções de simulados da OAB. Os
          resultados são projeções automáticas e podem conter imprecisões. Eles não representam nem
          substituem a correção oficial do Exame de Ordem.
        </p>
        <p className={styles.text}>
          Ao continuar, você declara estar ciente destas limitações e concorda com nossos Termos de
          Uso.
        </p>
        <a href="/termos" target="_blank" rel="noopener noreferrer" className={styles.link}>
          Ler termos completos
        </a>
        <div className={styles.actions}>
          <Button variant="primary" fullWidth onClick={handleAccept} disabled={loading}>
            {loading ? 'Aguarde...' : 'Li e concordo'}
          </Button>
        </div>
      </div>
    </Modal>
  );
}
